var scope_0 = require('/Users/photoroom/Development/References/grommet/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/448c87b07b98547d42eb1a1627ded4ac.js').default;
var scope_1 = require('/Users/photoroom/Development/References/grommet/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a85a85be43e040e579016980fc0b869b.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    